"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CollapsibleNav = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Panel = require("@fluentui/react/lib/components/Panel");

var _Nav = require("@fluentui/react/lib/Nav");

var _withResponsiveMode = require("@fluentui/react/lib/utilities/decorators/withResponsiveMode");

var React = _interopRequireWildcard(require("react"));

var _AppPanel = require("../AppPanel");

var _CollapsibleNav = require("./CollapsibleNav.classNames");

var _class;

var CollapsibleNav = (0, _withResponsiveMode.withResponsiveMode)(_class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CollapsibleNav, _React$Component);

  var _super = (0, _createSuper2.default)(CollapsibleNav);

  function CollapsibleNav() {
    (0, _classCallCheck2.default)(this, CollapsibleNav);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CollapsibleNav, [{
    key: "render",
    value: function render() {
      var nav = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Nav.Nav, (0, _objectSpread2.default)({}, this.props));
      var _this$props = this.props,
          isNavOpen = _this$props.isNavOpen,
          collapseNav = _this$props.collapseNav;
      var _this$props$responsiv = this.props.responsiveMode,
          responsiveMode = _this$props$responsiv === void 0 ? Infinity : _this$props$responsiv;

      var _getClassNames = (0, _CollapsibleNav.getClassNames)(),
          root = _getClassNames.root; // TODO: Should this be just a property called docked?


      if (responsiveMode <= _withResponsiveMode.ResponsiveMode.large) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppPanel.AppPanel, {
          className: root,
          isOpen: isNavOpen,
          type: _Panel.PanelType.smallFixedNear,
          isLightDismiss: true,
          onDismiss: collapseNav,
          children: nav
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ms-SideBar",
        children: nav
      });
    }
  }]);
  return CollapsibleNav;
}(React.Component)) || _class;

exports.CollapsibleNav = CollapsibleNav;